const services = [
  {
    icon: "ri-palette-line",
    title: "Identité visuelle & branding",
    description:
      "Création de logos, chartes graphiques et univers visuels cohérents pour forger une identité de marque forte et mémorable.",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Design graphique",
    description:
      "Conception de supports visuels modernes pour communication digitale et imprimée, avec une exigence esthétique de haut niveau.",
  },
  {
    icon: "ri-lightbulb-line",
    title: "Direction artistique",
    description:
      "Développement de concepts créatifs et accompagnement global des projets visuels, de l'idée à la réalisation finale.",
  },
];

export default function ServicesSection() {
  return (
    <section className="bg-brand-beige-light py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        {/* Section label */}
        <div className="mb-16">
          <span className="font-sans text-xs tracking-widest uppercase text-brand-gris-light">
            Services
          </span>
          <h2 className="font-serif font-light text-brand-noir text-4xl lg:text-5xl mt-4 max-w-xl leading-tight">
            Une expertise créative complète
          </h2>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-10 lg:p-12 group hover:-translate-y-2 transition-all duration-400 cursor-default"
              style={{ transition: "transform 0.4s cubic-bezier(0.4,0.0,0.2,1), box-shadow 0.4s cubic-bezier(0.4,0.0,0.2,1)" }}
            >
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center mb-8">
                <i className={`${service.icon} text-2xl text-brand-noir group-hover:text-brand-or transition-colors duration-300`}></i>
              </div>

              {/* Title */}
              <h3 className="font-serif font-light text-brand-noir text-2xl lg:text-3xl mb-5 leading-snug">
                {service.title}
              </h3>

              {/* Description */}
              <p className="font-sans font-light text-brand-gris text-sm leading-loose">
                {service.description}
              </p>

              {/* Gold accent */}
              <div className="mt-8 w-10 h-0.5 bg-brand-or group-hover:w-20 transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
